<template>
    <div id="search-bannerr" ref="searchBanner" class="mt-3">
      <div class="container-banner">
        <div class="search-location">
          <img src="../../images/Loupe.png" v-set-alt class="icon" />
          <input
              class="raleway-reg-p15 search-bar-location"
              type="text"
              placeholder="Recherchez un hôtel, une destination"
              v-model="search"
              @input="fetchSuggestions"
              @focus="showSuggestions = true"
              ref="searchInput"
          />
          <div v-if="showSuggestions" class="suggestions-dropdown">
            <template v-for="(section, key) in suggestions">
              <div v-if="section.length" class="suggestion-group">
                <div class="suggestion-header">{{ sectionTitles[key] }}</div>
                <div
                  v-for="(item, index) in section"
                  :key="item.id"
                  class="suggestion-card-wrapper"
                >
                  <div class="suggestion-card" @click.stop="handleSuggestionClick(key, item)">
                    {{ item.name }}
                  </div>
                  <div v-if="index !== section.length - 1" class="suggestion-divider"></div>
                </div>
              </div>
            </template>
          </div>
        </div>
        <span class="separator">|</span>
        <div class="search-duration">
          <img src="../../images/3.png" v-set-alt class="icon" />
          <CommonDatePicker
              :startDate="minDate"
              :endDate="maxDate"
              ref="datePicker"
              @periodSelected="selectDates"
          />
        </div>
        <span class="separator">|</span>
        <div class="search-number">
          <img src="../../images/pers.png" v-set-alt class="icon" />
          <input
              class="raleway-reg-p15 search-bar-top text-center"
              @click="showGuestInfo = !showGuestInfo"
              :placeholder="formatAdults() + ' - ' + formatChilds()"
          />
          <Guestinfo
              v-if="showGuestInfo"
              @ageSelected="updateAges"
              @increaseRooms="updateRooms"
              @decreaseRooms="updateRooms"
              @increaseChilds="updateChilds"
              @decreaseChilds="updateChilds"
              @increaseAdults="updateAdults"
              @decreaseAdults="updateAdults"
              @closed="handleClose"
              :initialAdults="adults"
              :initialChilds="childs"
              :initialChildAges="childAges"
          />
        </div>
        <div class="search-location">
          <a class="around-btn link-hortense" @click="getLocation">
          <img src="../../images/Localisation.svg" v-set-alt />
          Autour de moi
        </a>
        </div>
        <template>
          <button class="hortense-btn-primary" style="height: 5.5vh; width: 10vw;" :disabled="disableGoButton" @click="performSearch">
            <div class="search-button">
              {{ searchButtonCaption }}
            </div>
          </button>
        </template>
      </div>
    </div>
  </template>
  
  <script>
    import Guestinfo from "components/btns/Guestinfo.vue";
    import { VueDatePicker } from "@mathieustan/vue-datepicker";
    import fetcher from '../../packs/shared/api.js';
    import _ from 'lodash';
    
    export default {
    name: "MainSearch",
    components: { Guestinfo, VueDatePicker },
    data() {
      return {
        lat: "",
        long: "",
        not_enable: false,
        valtemp: "",
        selectedDates: [],
        showGuestInfo: false,
        rooms: 1,
        childs: 0,
        adults: 1,
        childAges: [],
        color: "#CDDFD3",
        date: new Date(),
        currentDate: new Date(),
        display: true,
        isSearching: false,
        searchResults: null,
        suggestions: {
        lodgings: [],
        departments: [],
        regions: [],
        cities: [],
        zones: [],
        territoires: []
      },
      showSuggestions: false,
      sectionTitles: {
        lodgings: 'Hébergements',
        departments: 'Départements',
        regions: 'Régions',
        cities: 'Villes',
        zones: 'Destinations',
        territoires: 'Destinations'
      },
        display: true,
      };
    },
    watch: {
      searched() {
        this.isSearching = !this.searched;
      },
      expandCalendar(new_value, old_value) {
        if (this.expandCalendar) {
          window.scrollTo({ top: 0, behavior: "smooth" });
          setTimeout(() => {
            this.$refs.datePicker.showDatepicker();
          }, 100);
        }
        this.$emit("updateExpandCalendar");
      },
    },
    beforeDestroy() {
      document.removeEventListener('click', this.handleClickOutside);
      if (this.scrollHandler) {
        window.removeEventListener('scroll', this.scrollHandler);
      }
      // Cancel any pending debounced calls
      if (this.debouncedFetchSuggestions) {
        this.debouncedFetchSuggestions.cancel();
      }
    },
    mounted() {
      document.addEventListener('click', this.handleClickOutside);
      const searchBanner = this.$refs.searchBanner;
      const offset = searchBanner.offsetTop;
  
      this.scrollHandler = () => {
        if (window.pageYOffset > offset) {
          searchBanner.classList.add('fixed');
        } else {
          searchBanner.classList.remove('fixed');
        }
      };
      window.addEventListener('scroll', this.scrollHandler);

      // Create debounced version of the API call
      this.debouncedFetchSuggestions = _.debounce(async () => {
        try {
          const response = await fetcher.get(`/lodgings/search_suggestions?query=${this.search}&geo=48.8575,2.3514`);
          this.suggestions = response.data;
          this.showSuggestions = true;
        } catch (error) {
          console.error('Error fetching suggestions', error);
        }
      }, 500);

      this.hydrateReservationState();

    },
    
    methods: {
      getLocation(){
      navigator.geolocation.getCurrentPosition((position) => {
        window.open(`/reservation-hotel?geo=${position.coords.latitude},${position.coords.longitude}`, '_blank');
      });
    },
      handleClose() {
        this.showGuestInfo = false;
      },
      formatKoediaDate(date) {
            if (date) {
              if (date.includes('-') || !date) {
                return date;
              }
              const dateBits = date.split('/');
              return `${dateBits[2]}-${dateBits[1]}-${dateBits[0]}`;
            } else {
            return null;
            }
        },
      getReservationState() {
        return JSON.parse(localStorage.getItem('reservationState') || '{}');
      },
      hydrateReservationState() {
        const state = this.getReservationState();

        if (state.search) {
          this.search = state.search;
        }
        if (state.adults !== undefined && state.adults !== null) {
          this.adults = parseInt(state.adults, 10);
        }
        if (state.childs !== undefined && state.childs !== null) {
          this.childs = parseInt(state.childs, 10);
        }
        if (Array.isArray(state.children_ages)) {
          this.childAges = this.normalizeChildAges(state.children_ages);
        }
        if ((state.koediaFrom || state.from) && (state.koediaTo || state.to)) {
          this.selectedDates = [
            state.koediaFrom || state.from,
            state.koediaTo || state.to,
          ];
        }
      },
        handleClickOutside(event) {
          const searchInput = this.$refs.searchInput;
          const suggestionsDropdown = this.$refs.suggestionsDropdown;

          if (
            searchInput &&
            !searchInput.contains(event.target) &&
            suggestionsDropdown &&
            !suggestionsDropdown.contains(event.target)
          ) {
            this.showSuggestions = false;
          }
        },
      selectDates(event, start, end) {
        this.selectedDates = [this.formatDate(start), this.formatDate(end)];

        const reservationState = this.getReservationState();
        const state = {
          ...reservationState,
          adults: this.adults,
          childs: this.childs,
          children_ages: this.normalizeChildAges(this.childAges),
        };

        if (this.selectedDates && this.selectedDates.length === 2 && this.selectedDates[0] && this.selectedDates[1]) {
          state.koediaFrom = this.formatKoediaDate(this.selectedDates[0]);
          state.koediaTo = this.formatKoediaDate(this.selectedDates[1]);
          state.from = this.formatKoediaDate(this.selectedDates[0]);
          state.to = this.formatKoediaDate(this.selectedDates[1]);
          localStorage.setItem('reservationState', JSON.stringify(state));
        } else {
          localStorage.setItem('reservationState', JSON.stringify(state));
          console.log('Selected dates are not properly set');
        }
      },
      formatDate(date) {
        if (!date) return null;
        const set = new Date(date);
        const options = { year: "numeric", month: "numeric", day: "numeric" };
        return set.toLocaleString("fr", options);
      },
      getLocation() {
        navigator.geolocation.getCurrentPosition(function (position) {
          let lat = position.coords.latitude;
          let long = position.coords.longitude;
          window.open(`/reservation-hotel?geo=${lat},${long}`, '_blank');
          // Turbolinks.visit(`/reservation-hotel?geo=${lat},${long}`);
        });
      },
      updateRooms(room) {
        this.rooms = room;
        this.$emit("numberOfRoom", this.rooms);
      },
      formatRooms() {
        let chambre = " Chambre";
        if (this.rooms > 1) {
          chambre += "s";
        }
        return this.rooms + chambre;
      },
      updateChilds(child) {
        this.childs = child;
        this.$emit("numberOfChild", this.childs);
        this.setreservationStateCacheForAdultsAndChilds();
      },
      formatChilds() {
        let enfant = " Enfant";
        if (this.childs > 1) {
          enfant += "s";
        }
        return this.childs + enfant;
      },
      updateAdults(adult) {
        this.adults = adult;
        this.$emit("numberOfAdult", this.adults);
        this.setreservationStateCacheForAdultsAndChilds();
      },
      setreservationStateCacheForAdultsAndChilds() {
        const state = JSON.parse(localStorage.getItem('reservationState')) || {};
        state.adults = this.adults;
        state.childs = this.childs;
        state.children_ages = this.normalizeChildAges(this.childAges);
        localStorage.setItem('reservationState', JSON.stringify(state));
      },
      updateAges(value) {
        this.childAges = this.normalizeChildAges(value);
        this.$emit("ageOfChild", this.childAges);
        this.setreservationStateCacheForAdultsAndChilds();
      },
      formatAdults() {
        let adulte = " Adulte";
        if (this.adults > 1) {
          adulte += "s";
        }
        return this.adults + adulte;
      },
      formatDateSyntax(dateString) {
        let dateParts = dateString.split('/');
  
        let day = dateParts[0];
        let month = dateParts[1];
        let year = dateParts[2].slice(-2);
  
        return `${day}/${month}/${year}`;
      },
      formatDateKoedia(date) {
        if (!date) return null;
        if (date.includes('-')) {
          return date;
        }
        const dateBits = date.split('/');
        return `${dateBits[2]}-${dateBits[1]}-${dateBits[0]}`; 
      },
      normalizeChildAges(ages) {
        if (!Array.isArray(ages)) return [];
        return ages.filter(age => age !== null && age !== undefined && age !== '');
      },
      performSearch() {
        this.$emit("selectDates", this.selectedDates);
        this.isSearching = true;
        const path = window.location.pathname;
        
        // Save search state to localStorage instead of URL params
        const reservationState = {
          search: this.search,
          childs: this.childs,
          adults: this.adults,
          children_ages: this.normalizeChildAges(this.childAges),
          koediaFrom: this.selectedDates ? this.formatKoediaDate(this.selectedDates[0]) : null,
          koediaTo: this.selectedDates ? this.formatKoediaDate(this.selectedDates[1]) : null,
          from: this.selectedDates ? this.formatKoediaDate(this.selectedDates[0]) : null,
          to: this.selectedDates ? this.formatKoediaDate(this.selectedDates[1]) : null,
          base: path.includes("/vacances-printemps") ? 'spring' : path.includes("/vacances-ete")  ? 'summer' : ''
        };
        localStorage.setItem('reservationState', JSON.stringify(reservationState));
        
        window.dataLayer = window.dataLayer || [];
        let bookingWindow = null;

        if (this.selectedDates && this.selectedDates[0]) {
          const dateInParts = this.selectedDates[0].split('/');
          const dateIn = new Date(`${dateInParts[2]}-${dateInParts[1]}-${dateInParts[0]}`);
          const today = new Date();
          const timeDifference = dateIn - today;
          bookingWindow = Math.ceil(timeDifference / (1000 * 60 * 60 * 24));
        }

        const dateIn = this.selectedDates ? this.selectedDates[0] : null;
        const dateOut = this.selectedDates ? this.selectedDates[1] : null;

        const numberOfNights = (dateIn && dateOut)
          ? Math.ceil((new Date(dateOut) - new Date(dateIn)) / (1000 * 60 * 60 * 24))
          : null;

        window.dataLayer.push({
          event: 'search',
          ecommerce: {
            search_term: this.search,
            booking_window: bookingWindow,
            date_in: this.selectedDates ? this.formatKoediaDate(this.selectedDates[0]) : null,
            date_out: this.selectedDates ? this.formatKoediaDate(this.selectedDates[1]) : null,
            number_of_people: parseInt(this.adults || 2) + parseInt(this.childs || 0),
            number_of_adult: this.adults,
            number_of_child: this.childs,
            results: 93,
            number_of_nights: numberOfNights
          }
        });

        window.location.href = `/reservation-hotel`;
      },
    fetchSuggestions() {
      if (this.search.length < 3) {
        this.resetSuggestions();
        this.showSuggestions = false;
        return;
      }
      // Call the debounced function
      this.debouncedFetchSuggestions();
    },
    resetSuggestions() {
      this.suggestions = { lodgings: [], departments: [], regions: [], cities: [], zones: [], territoires: [] };
    },
    goToAccommodation(id) {
      window.open(`/reservation-hotel/${id}`, '_blank');
    },
    goToDestination(slug) {
      window.open(`/destination/${slug}`, '_blank');
    },
    goToDestinationTwo(id){
      window.open(`/reservation-hotel?zone=${id}`, '_blank');
    },
    goToDestinationThree(id){
      window.open(`/reservation-hotel?territoire=${id}`, '_blank');
    },
    handleSuggestionClick(type, item) {
      this.search = item.name;
      this.showSuggestions = false;
    },
    },
    computed: {
      searchButtonCaption() {
        return this.isSearching ? "Recherche..." : "RECHERCHER";
      },
      disableSearchButton() {
        return this.isSearching;
      },
      disableGoButton() {
        return false;
      },
      minDate() {
        return new Date(
            this.currentDate.getFullYear(),
            this.currentDate.getMonth(),
            this.currentDate.getDate()
        );
      },
      maxDate() {
        return new Date(
            this.currentDate.getFullYear() + 1,
            this.currentDate.getMonth(),
            this.currentDate.getDate()
        );
      },
    },
  };
  </script>
  
  <style scoped>
  #search-bannerr {
    padding: 1rem;
    width: 95%;
    height: 9vh !important;
    margin: 0 auto;
    height: auto;
    display: flex;
    align-items: center;
    justify-content: space-between;
    border: 1px solid #e0e0e0;
    background: #fff 0% 0% no-repeat padding-box;
    box-shadow: 5px 3px 6px #00000029;
    opacity: 1;
    transition: all 0.3s ease-in-out; /* Smooth transition */

    @media screen and (max-width: 1400px) {
      width: 100%
    }
  }
  
  #search-bannerr.fixed {
    position: fixed;
    top: 4.5%;
    left: 50%;
    transform: translateX(-50%);
    width: 100%;
    z-index: 1000;
    margin-top: 0px !important;
  }
  
  .container-banner {
    width: 100%;
    display: flex;
    justify-content: space-between;
    align-items: center;
    flex-wrap: nowrap; /* Allow wrapping */
  }
  
  .search-location,
  .search-duration,
  .search-location,
  .search-number {
    display: flex;
    align-items: center;
    flex-shrink: 0;
  }

  .search-number {
    position: relative;
    z-index: 4000;
    overflow: visible;
  }
  
  .search-bar-location {
  background-color: white;
  border-width: 0px;
  width: 260px; /* Slightly reduce width for better spacing */
}

.search-bar-top {
  background-color: white;
  border-width: 0px;
  width: 150px; /* Adjust width for guest info input */
  text-align: center;
}
  
  .search-bar-location::placeholder,
  .search-bar-top::placeholder {
    color: black;
  }
  
  .search-bar-location:focus,
  .search-bar-top:focus {
    outline: none;
    box-shadow: none;
  }
  
  .icon {
    margin-right: 0.5rem;
  }
  
  .separator {
    color: grey;
    margin: 0 1rem;
  }
  
  .hortense-btn-primary {
    padding: 8px 16px;
    background-color: #3b6152;
    color: white;
    border: none;
    cursor: pointer;
    flex-shrink: 0;
  }
  
  .no-deco {
    text-decoration: none;
  }
  
  .no-deco.text-white {
    color: white;
  }
  
  .close-button {
    background: none;
    border: none;
    cursor: pointer;
  }

  .around-btn {
  cursor: pointer;
  width: 130px; /* Adjust button width */
  display: flex;
  justify-content: center;
  align-items: center;
  color: black !important;
  font-size: 0.9rem !important;
  margin-right: 10px;
}

.around-btn img {
  width: 20px;
  height: 20px;
  margin-right: 5px;
}
.suggestions-dropdown {
  position: absolute;
  top: 100%;
  left: 0;
  width: 100%;
  background: #f9f9f9;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.08);
  border-radius: 8px;
  margin-top: 5px;
  max-height: 300px;
  overflow-y: auto;
  z-index: 1000;
  font-family: Raleway;
}

.suggestion-group {
margin-bottom: 20px;
}

.suggestion-header {
font-weight: bold;
font-size: 14px;
color: #3b6152;
padding: 10px 20px 5px;
text-transform: uppercase;
background: transparent;
font-family: Raleway;
}

.suggestion-card-wrapper {
padding: 0 20px;
}

.suggestion-card {
font-size: 16px;
color: #3b6152;
cursor: pointer;
padding: 10px 0;
font-family: Raleway;
}

.suggestion-card:hover {
background: #eef3f0;
}

.suggestion-divider {
width: 100%;
height: 1px;
background: #3b6152;
}

.search-location {
  position: relative;
}

#guest-info {
  position: absolute;
  top: calc(100% + 8px);
  right: 0;
  z-index: 4001;
}

</style>
